var React = require('react');

function IconGoto (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.77778 20C5.28889 20 4.87022 19.8258 4.52178 19.4773C4.17333 19.1289 3.99941 18.7105 4 18.2222V5.77778C4 5.28889 4.17422 4.87022 4.52267 4.52178C4.87111 4.17333 5.28948 3.99941 5.77778 4H12V5.77778H5.77778V18.2222H18.2222V12H20V18.2222C20 18.7111 19.8258 19.1298 19.4773 19.4782C19.1289 19.8267 18.7105 20.0006 18.2222 20H5.77778ZM9.95556 15.2889L8.71111 14.0444L16.9778 5.77778H13.7778V4H20V10.2222H18.2222V7.02222L9.95556 15.2889Z","fill":"white"}));
}

IconGoto.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconGoto;

IconGoto.default = IconGoto;
